import React, { Component } from "react";
import Loading from '../../hoc/Loading/Loading';
import {withRouter} from 'react-router-dom';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import axios from '../../axios';
import './Events.css';
import * as url from '../../utils/url';
import EventListItem from './EventListItem'
import noEventUsers from '../../assets/onboarding/wStory.svg'

class EventList extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          events:[],
          isLoaded:false
        };
      }


      componentDidMount(){
        let that=this
        console.log('this props---', this.props)
        let userId = this.props.currentUser && this.props.currentUser._id?this.props.currentUser._id: this.props.user.profile._id
        axios.post(url.getUserEvents, {userId}).then(({ data }) => {
          let resp = data.data
          console.log('events---', resp)

          that.setState({
              events: resp,
              isLoaded: resp.length==0?true:false
          })
        }).catch((error) => {
          console.log(error);
        }) 
      }

   
      

      // navCreateGrp=()=>{
      //   this.props.history.push(`/home/groups/${this.props.user.profile.organizationId._id}/create`)
      // }

  renderEventsList = () =>{
    let{events}=this.state,
    {match, user}=this.props
    
    let filtered_events=events

    let curr_user_vs_profile = match.url.indexOf(user.profile._id)>-1 || user.profile.orgAdmin ? true: false
    let userId = user.profile._id
    let groups = user.profile.groups

    if(!curr_user_vs_profile){
      filtered_events = events.filter(e=> {
        let{eventId}=e
        if( 
             ( e.hasOwnProperty('invitedBy') && e.invitedBy._id==userId )
              || eventId.createdBy == userId 
              || eventId.privacy != 'PRIVATE'
              || (eventId.invitedUsers.length>0 && eventId.invitedUsers.filter(e=> e.value==userId).length>0 )
              || (groups.length>0 && groups.filter(e=> e.o_id == eventId.groupId).length>0 )
        ){
          return e
        }
      })
    }

    if(filtered_events.length>0){
      return (filtered_events.map((item,idx)=>{
        return item && item.eventId && <div className={`col-md-4 grp_list_page_item_container`} key={item._id+idx} > <EventListItem item={item} /> </div>
      }))
    } else {
      return(<div className="event_guest_modal_no_data">
          <img src={noEventUsers} className="event_guest_modal_no_data_img"/>
          <span className="event_guest_modal_no_data_txt">No events.</span>
        </div>)
    }

  }


  renderContent =()=>{
    let { events , isLoaded} = this.state, no_events
  
    if(!isLoaded && (events.length==0)){
      let item = {
        eventId: { name:'Loading events...', subCategory:''  }
      }
      return <div className="col-md-4 grp_list_page_item_container"> <EventListItem item={item} /> </div>
    } else {
        if(events.length>0){
          return this.renderEventsList()
        }else {
          return(<div className="event_guest_modal_no_data">
                <img src={noEventUsers} className="event_guest_modal_no_data_img"/>
                <span className="event_guest_modal_no_data_txt">No events have been RSVP'd.</span>
              </div>)
        }
    } 
  }


  render() {
    let { events , isLoaded} = this.state, no_events
     if(events.length==0){
      no_events = {
        name:'Loading events...'
      }
     }
    return (
      <span>
      {/* <div className="grp_list_page_container col-md-11 col-lg-11 col-sm-11">
        <div className="grp_list_page_container_title">events</div>
        <div className="grp_list_page_container_createBtn" onClick={()=>this.navCreateGrp()}>+ Create Group</div>
      </div> */}
      <div className="grp_list_page_container_pinGrid">

        {this.renderContent()}
      
      </div>
    </span>
    );
  }
}



const mapStateToProps = state => {
    return {
      user: state.user,
      objectives: state.enterpriseObjective.objectives
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onFetchEnterpriseObjectives: (data) => dispatch(actionCreators.storeEnterpriseObjectives(data)),
      orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
      resetObjective : () => dispatch(actionCreators.resetEnterpriseObjectives())
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(EventList, axios)));